<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.client.name }}</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-4 is-offset-1">
        <p class="title is-4">{{ this.$store.state.client.name }}</p>
        <p><span class="has-text-grey">Application ID:</span> {{ $route.params.client_id }}</p>
        <p><span class="has-text-grey">Package name:</span> {{ this.$store.state.client.package_name }}</p>
        <p><span class="has-text-grey">Platform:</span> {{ this.$store.state.client.platform }}<p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.client.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.client.updated_at }}</p>
      </div>
      <div class="column is-4">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Devices</p>
              <p class="subtitle is-4">
                <router-link v-bind:to="`/clients/${this.$store.state.client.id}/devices`">{{ this.$store.state.client.devices_count | numberDisplay }}</router-link>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Cameras</p>
              <p class="subtitle is-4">
                <router-link v-bind:to="`/clients/${this.$store.state.client.id}/cameras`">{{ this.$store.state.client.cameras_count | numberDisplay }}</router-link>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Articles</p>
              <p class="subtitle is-4">
                <router-link v-bind:to="`/clients/${this.$store.state.client.id}/articles`">{{ this.$store.state.client.articles_count | numberDisplay }}</router-link>
              </p>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-2 is-offset-1">
        <div class="control is-grouped">
          <div class="control">
            <router-link v-bind:to="`/clients/${this.$store.state.client.id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="column"></div>

    <div class="columns">
      <div class="column is-half is-offset-one-quarter">
        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <div class="control has-icons-left">
                <datepicker v-model="startDate"></datepicker>
                <span class="icon is-small is-left"><i class="fa fa-calendar"></i></span>
              </div>
            </div>

            <div class="field">
              <div class="control has-icons-left">
                <datepicker v-model="endDate"></datepicker>
                <span class="icon is-small is-left"><i class="fa fa-calendar"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Devices during this period</p>
          <p class="subtitle is-4">{{ devicesByPeriodsTotal | numberDisplay }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Cameras during this period</p>
          <p class="subtitle is-4">{{ camerasByPeriodsTotal | numberDisplay }}</p>
        </div>
      </div>
    </nav>

    <div class="columns">
      <div class="column is-6">
        <article class="box">
          <chartjs-bar
            v-bind:datalabel="'Devices by period'"
            v-bind:backgroundcolor="'rgba(255, 99, 132, 0.5)'"
            v-bind:bordercolor="'rgba(255,99,132,1)'"
            v-bind:borderwidth="1"
            v-bind:bind="true"
            v-bind:labels="devicePeriods"
            v-bind:data="deviceAmounts">
          </chartjs-bar>
        </article>
      </div>
      <div class="column is-6">
        <article class="box">
          <chartjs-bar
            v-bind:datalabel="'Cameras by period'"
            v-bind:backgroundcolor="'rgba(255, 206, 86, 0.5)'"
            v-bind:bordercolor="'rgba(255, 206, 86, 1)'"
            v-bind:borderwidth="1"
            v-bind:bind="true"
            v-bind:labels="cameraPeriods"
            v-bind:data="cameraAmounts">
          </chartjs-bar>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  import moment from 'moment'

  export default {
    data () {
      return {
        startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      }
    },

    computed: {
      daysTotal () {
        return moment(this.endDate).diff(moment(this.startDate), 'days')
      },

      devicesByPeriods () {
        let date = moment(this.startDate)
        let amounts = {}
        let result = {}

        this.$store.state.clientDevicesByPeriods.forEach(function (item) {
          amounts[item.period] = item.amount
        })

        while (date <= moment(this.endDate)) {
          result[date.format('YYYY-MM-DD')] = amounts[date.format('YYYY-MM-DD')] || 0

          date.add(1, 'days')
        }

        return result
      },

      devicePeriods () {
        return Object.keys(this.devicesByPeriods)
      },

      deviceAmounts () {
        return Object.values(this.devicesByPeriods)
      },

      camerasByPeriods () {
        let date = moment(this.startDate)
        let amounts = {}
        let result = {}

        this.$store.state.clientCamerasByPeriods.forEach(function (item) {
          amounts[item.period] = item.amount
        })

        while (date <= moment(this.endDate)) {
          result[date.format('YYYY-MM-DD')] = amounts[date.format('YYYY-MM-DD')] || 0

          date.add(1, 'days')
        }

        return result
      },

      cameraPeriods () {
        return Object.keys(this.camerasByPeriods)
      },

      cameraAmounts () {
        return Object.values(this.camerasByPeriods)
      },

      devicesByPeriodsTotal () {
        return this.deviceAmounts.reduce((sum, current) => sum + current)
      },

      camerasByPeriodsTotal () {
        return this.cameraAmounts.reduce((sum, current) => sum + current)
      }
    },

    watch: {
      startDate () {
        this.getDataForGraphs()
      },
      endDate () {
        this.getDataForGraphs()
      }
    },

    methods: {
      getDataForGraphs () {
        this.$store.dispatch('getClientDevicesByPeriods', {
          client_id: this.$route.params.client_id,
          created_after: this.startDate,
          created_before: `${this.endDate} 23:59:59`,
          limit: this.daysTotal
        })

        this.$store.dispatch('getClientCamerasByPeriods', {
          client_id: this.$route.params.client_id,
          created_after: this.startDate,
          created_before: `${this.endDate} 23:59:59`,
          limit: this.daysTotal
        })
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id,
        params: {
          include: 'devices_count,cameras_count,articles_count'
        }
      })

      this.getDataForGraphs()
    },

    components: {
      Datepicker
    }
  }
</script>



// WEBPACK FOOTER //
// ClientView.vue?449531b6